import React from 'react';
import { Avatar, List, Skeleton } from 'antd';
import { Text } from './Text';
export const ListItems = ({ items, itemLayout = 'vertical', }) => {
    return (React.createElement(List, { itemLayout: itemLayout, dataSource: items, renderItem: (item) => (React.createElement(List.Item, { actions: item.buttons },
            React.createElement(Skeleton, { avatar: true, title: false, loading: item.loading, active: true },
                React.createElement(List.Item.Meta, { avatar: item.avatar ? (React.createElement(Avatar, { shape: item.avatar?.shape, src: item.avatar?.url, size: item.avatar?.size || 'small', style: {
                            borderRadius: 1,
                            backgroundColor: 'transparent',
                        }, icon: item.avatar?.icon })) : null, title: React.createElement("a", { href: item.href, onClick: item.onClick }, item.header), description: item.subheader }),
                React.createElement(Text, { value: item.content })))) }));
};
